import hasRegularAvailability from "./hasRegularAvailability";
import hasRegularTable from "./hasRegularTable";
import { type RestaurantDetailsById } from "../../model/restaurants/byId";
import { type RegularAvailabilityById } from "../../model/types";

export default function shouldShowRegularSection(
  discountOnly: boolean | null,
  hasLastTable: boolean,
  restaurantsById: RestaurantDetailsById,
  session: SessionType,
  people: number,
  timesIsSet: boolean,
  regularAvailabilityById: RegularAvailabilityById,
  date: string,
  isSingleMode: boolean,
  restaurantId: number,
  showDiscountSection: boolean,
) {
  // only show the regular section if the discount section isn't shown
  if (showDiscountSection) {
    return false;
  }

  // should the section show based on the filters
  if (discountOnly || hasLastTable) {
    return false;
  }

  // should the section show based on restaurant attributes
  if (restaurantId === undefined) {
    return false;
  }

  const restaurantHasRegularTable = hasRegularTable(
    restaurantId,
    restaurantsById,
    session,
    people,
    isSingleMode,
  );

  if (!restaurantHasRegularTable) {
    return false;
  }

  // should the section show based on availability
  if (timesIsSet) {
    return hasRegularAvailability(regularAvailabilityById, date, restaurantId);
  }

  return true;
}
